// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments-section {
  margin-top: 2rem;
  padding: 1.5rem;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.comments-section .comments-loading-skeleton {
  padding: 0.25rem 0 0.5rem;
}
.comments-section .skeleton-comment-row {
  display: flex;
  gap: 0.75rem;
  padding: 0.75rem 0;
}
.comments-section .skeleton-comment-row:not(:last-child) {
  border-bottom: 1px solid #eee;
}
.comments-section .skeleton-avatar {
  flex: 0 0 32px;
  height: 32px;
  border-radius: 50%;
}
.comments-section .skeleton-lines {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
}
.comments-section .skeleton-line {
  height: 12px;
  border-radius: 4px;
}
.comments-section .skeleton-line-short {
  width: 35%;
}
.comments-section .skeleton-avatar,
.comments-section .skeleton-line {
  background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
  background-size: 200% 100%;
  animation: comments-skeleton-shimmer 1.4s ease-in-out infinite;
}
.comments-section .comments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
}
.comments-section .comments-header .comments-title h4 {
  display: flex;
  align-items: center;
  margin: 0;
  font-weight: 500;
  color: #333;
}
.comments-section .comments-header .comments-title h4 .comments-icon {
  margin-right: 0.5rem;
  color: #666;
}
.comments-section .comments-header .add-comment-btn {
  min-width: 140px;
}
.comments-section .comments-header .add-comment-btn mat-icon {
  margin-right: 0.5rem;
}
.comments-section .new-comment-form {
  margin-bottom: 2rem;
}
.comments-section .new-comment-form .comment-form-container {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.comments-section .new-comment-form .comment-textarea {
  width: 100%;
  margin-bottom: 1rem;
}
.comments-section .new-comment-form .comment-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}
.comments-section .new-comment-form .comment-actions .cancel-btn {
  color: #666;
}
.comments-section .new-comment-form .comment-actions .submit-btn {
  min-width: 120px;
}
.comments-section .comments-list .comment-thread {
  margin-bottom: 1.5rem;
}
.comments-section .comments-list .comment-thread:last-child {
  margin-bottom: 0;
}
.comments-section .comments-list .comment-item {
  display: flex;
  gap: 0.75rem;
  padding: 1rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-bottom: 0.75rem;
  position: relative;
}
.comments-section .comments-list .comment-item.root-comment {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.comments-section .comments-list .comment-item.reply-comment {
  background: #f8f9fa;
  border-color: #dee2e6;
  box-shadow: none;
}
.comments-section .comments-list .comment-item.reply-comment.level-1 {
  border-left: 3px solid #007bff;
}
.comments-section .comments-list .comment-item.reply-comment.level-2 {
  border-left: 3px solid #28a745;
}
.comments-section .comments-list .comment-item.reply-comment.level-3 {
  border-left: 3px solid #ffc107;
}
.comments-section .comments-list .comment-item.reply-comment .reply-avatar {
  font-size: 1.75rem;
  color: #6c757d;
}
.comments-section .comments-list .comment-item .comment-avatar {
  flex-shrink: 0;
}
.comments-section .comments-list .comment-item .comment-avatar .avatar-icon {
  font-size: 2.25rem;
  width: 2.25rem;
  height: 2.25rem;
  color: #666;
}
.comments-section .comments-list .comment-item .comment-content {
  flex: 1;
  min-width: 0;
}
.comments-section .comments-list .comment-item .comment-content .comment-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .comment-author {
  font-weight: 600;
  color: #333;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .comment-author .author-role-badge {
  font-weight: 400;
  font-size: 0.75em;
  margin-left: 0.3rem;
  padding: 0.1rem 0.45rem;
  background-color: rgba(100, 100, 100, 0.08);
  border-radius: 12px;
  border: 1px solid rgba(100, 100, 100, 0.2);
  color: #555;
  vertical-align: middle;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .comment-author .author-badge {
  font-weight: 500;
  color: #2196f3;
  font-size: 0.8em;
  margin-left: 0.25rem;
  padding: 0.1rem 0.4rem;
  background-color: rgba(33, 150, 243, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(33, 150, 243, 0.2);
}
.comments-section .comments-list .comment-item .comment-content .comment-header .comment-date {
  color: #666;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .edited-badge {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #6c757d;
  font-size: 0.75rem;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .edited-badge .edited-icon {
  font-size: 1rem;
  width: 1rem;
  height: 1rem;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .status-open {
  color: #e65100;
  border-color: #e65100;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .status-adopted {
  color: #2e7d32;
  border-color: #2e7d32;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .status-closed {
  color: #546e7a;
  border-color: #546e7a;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .resolution-status-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.15rem 0.5rem;
  border-radius: 12px;
  border: 1px solid;
  background: transparent;
  white-space: nowrap;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .resolution-status-select {
  font-size: 0.75rem;
  font-weight: 600;
  min-width: 90px;
  width: auto;
}
.comments-section .comments-list .comment-item .comment-content .comment-header .resolution-status-select ::ng-deep .mat-mdc-select-trigger {
  padding: 0.15rem 0.5rem;
  border-radius: 12px;
  border: 1px solid;
  white-space: nowrap;
}
.comments-section .comments-list .comment-item .comment-content .comment-text {
  color: #333;
  line-height: 1.5;
  margin-bottom: 0.75rem;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.comments-section .comments-list .comment-item .comment-content .comment-edit-form {
  margin-bottom: 0.75rem;
}
.comments-section .comments-list .comment-item .comment-content .comment-edit-form .comment-textarea {
  width: 100%;
  margin-bottom: 1rem;
}
.comments-section .comments-list .comment-item .comment-content .comment-edit-form .comment-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}
.comments-section .comments-list .comment-item .comment-content .comment-edit-form .comment-actions .cancel-btn {
  color: #666;
}
.comments-section .comments-list .comment-item .comment-content .comment-edit-form .comment-actions .submit-btn {
  min-width: 120px;
}
.comments-section .comments-list .comment-item .comment-content .comment-actions-bar {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.comments-section .comments-list .comment-item .comment-content .comment-actions-bar .action-btn {
  min-width: auto;
  padding: 0.25rem 0.75rem;
  font-size: 0.875rem;
  color: #666;
}
.comments-section .comments-list .comment-item .comment-content .comment-actions-bar .action-btn:hover {
  color: #007bff;
  background-color: rgba(0, 123, 255, 0.05);
}
.comments-section .comments-list .comment-item .comment-content .comment-actions-bar .action-btn mat-icon {
  margin-right: 0.25rem;
  font-size: 1rem;
  width: 1rem;
  height: 1rem;
}
.comments-section .comments-list .comment-item .comment-content .comment-actions-bar .action-btn.reply-btn mat-icon {
  transform: scaleX(-1);
}
.comments-section .comments-list .comment-item .comment-content .comment-actions-bar .action-btn.delete-btn {
  color: #c62828;
}
.comments-section .comments-list .comment-item .comment-content .comment-actions-bar .action-btn.delete-btn:hover {
  color: #b71c1c;
  background-color: rgba(198, 40, 40, 0.05);
}
.comments-section .comments-list .comment-item .comment-content .reply-form {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e9ecef;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 6px;
  padding: 1rem;
}
.comments-section .comments-list .comment-item .comment-content .reply-form .comment-textarea {
  width: 100%;
  margin-bottom: 1rem;
}
.comments-section .comments-list .comment-item .comment-content .reply-form .comment-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}
.comments-section .comments-list .comment-item .comment-content .reply-form .comment-actions .cancel-btn {
  color: #666;
}
.comments-section .comments-list .comment-item .comment-content .reply-form .comment-actions .submit-btn {
  min-width: 100px;
}
.comments-section .comments-list .replies-container {
  margin-left: 1rem;
  padding-left: 1rem;
  border-left: 2px solid #e9ecef;
}
.comments-section .comments-list .replies-container .comment-item {
  position: relative;
}
.comments-section .comments-list .replies-container .comment-item::before {
  content: "";
  position: absolute;
  top: 2rem;
  left: -1rem;
  width: 0.75rem;
  height: 2px;
  background-color: #e9ecef;
}
.comments-section .empty-comments {
  text-align: center;
  padding: 3rem 1rem;
}
.comments-section .empty-comments .empty-content .empty-icon {
  font-size: 3rem;
  width: 3rem;
  height: 3rem;
  color: #ccc;
  margin-bottom: 1rem;
}
.comments-section .empty-comments .empty-content h5 {
  margin: 0 0 0.5rem 0;
  color: #666;
  font-weight: 500;
}
.comments-section .empty-comments .empty-content p {
  margin: 0 0 1.5rem 0;
  color: #888;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 768px) {
  .comments-section {
    padding: 1rem;
  }
  .comments-section .comments-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  .comments-section .comments-header .add-comment-btn {
    width: 100%;
  }
  .comments-section .comments-list .comment-item {
    padding: 0.75rem;
  }
  .comments-section .comments-list .comment-item .comment-avatar .avatar-icon {
    font-size: 1.75rem;
    width: 1.75rem;
    height: 1.75rem;
  }
  .comments-section .comments-list .replies-container {
    margin-left: 0.5rem;
    padding-left: 0.5rem;
  }
  .comments-section .comments-list .replies-container .comment-item[style*=margin-left] {
    margin-left: 0.5rem;
  }
  .comments-section .comment-actions {
    flex-direction: column;
    gap: 0.5rem;
  }
  .comments-section .comment-actions .cancel-btn,
  .comments-section .comment-actions .submit-btn {
    width: 100%;
  }
}
.comments-section.comments-readonly {
  border-left: 4px solid #e0e0e0;
  background-color: #fafafa;
}
.comments-section.comments-readonly .comments-title h4 {
  color: #666;
}
.comments-section.comments-readonly .comments-title h4 .comments-icon {
  color: #999;
}
.comments-section.comments-readonly .comment-item {
  background-color: transparent;
}
.comments-section.comments-readonly .comment-item .comment-text {
  color: #555;
}
.comments-section.comments-readonly .comment-item .comment-actions-bar .action-btn {
  color: #888;
}
.comments-section.comments-readonly .comment-item .comment-actions-bar .action-btn:hover {
  color: #555;
}
.comments-section.comments-readonly .comment-avatar .avatar-icon {
  color: #999;
}

::ng-deep .comments-section .mat-mdc-form-field-hint-wrapper,
::ng-deep .comments-section .mat-mdc-form-field-error-wrapper {
  padding: 0 1rem;
}
::ng-deep .comments-section .mat-mdc-text-field-wrapper {
  background-color: white;
}
::ng-deep .comments-section .mat-mdc-form-field-focus-overlay {
  background-color: transparent;
}

@keyframes comments-skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
